import { Map } from 'immutable';

import createTypedReducer from '../createTypedReducer';
import * as deviceNavActions from './action';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';
import type { DeviceNavNode, DeviceNavTab } from 'src/service/api/deviceNav';

/* Values are plain JS, set with .set() only. */
export const initialState = Map<string, any>({
  tab: null as DeviceNavTab | null,
  items: [] as DeviceNavNode[],
  total: null as number | null,
  loading: false,
  error: null,
});

const reset = () => initialState;

export const deviceNavReducer = createTypedReducer(initialState, {
  [deviceNavActions.FETCH_DEVICE_NAV] (state, action) {
    // Keep the items while refetching the same tab, so a filter change doesn't flash a skeleton.
    const base = state.get('tab') === action.tab ? state : reset().set('tab', action.tab);
    return base.set('loading', true).set('error', null);
  },

  [deviceNavActions.FETCH_DEVICE_NAV_SUCCESS] (state, action) {
    if (action.nav.by !== state.get('tab')) {
      return state;
    }
    return state.withMutations((nextState) =>
      nextState
        .set('items', action.nav.items)
        .set('total', action.nav.total)
        .set('loading', false)
    );
  },

  [deviceNavActions.FETCH_DEVICE_NAV_FAILED] (state, action) {
    return state.set('loading', false).set('error', action.err);
  },

  [CHANGE_CLIENT]: reset,
  [CLEAR]: reset,
});
